import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/AccountSettings.css';
import axios from 'axios';

function AccountSettings() {
  const API_URL = process.env.REACT_APP_API_URL;
  
  const userEmail = localStorage.getItem("userEmail") || "Brak emaila";
  const [storageUsed, setStorageUsed] = useState(0.00);
  const [storageLimit, setStorageLimit] = useState(0.00);
  const [africa, setAfrica] = useState(false);
  const [europe, setEurope] = useState(false);
  const [asia, setAsia] = useState(false);
  const [nthAmerica, setNthAmerica] = useState(false);
  const [sthAmerica, setSthAmerica] = useState(false);
  const [australia, setAustralia] = useState(false);
  const [antarctica, setAntarctica] = useState(false);
  const [countriesNo, setCountriesNo] = useState(0);

  useEffect(() => {
    const fetchUserStats = async () => {
      if (!userEmail || userEmail === "Brak emaila") return;

      try {
        console.log("Wysyłam email:", userEmail);
        const response = await axios.post(`${API_URL}/users/get-countries-no`, {
          email: userEmail
        });

        if (response.data) {
          console.log("Otrzymane odznaki:", response.data);
          setStorageUsed((response.data.StorageUsed / (1024 * 1024)).toFixed(2) || 0.00)
          setStorageLimit((response.data.StorageLimit / (1024 * 1024)).toFixed(2) || 0.00);
          setAfrica(response.data.Africa || false);
          setEurope(response.data.Europe || false);
          setAsia(response.data.Asia || false);
          setNthAmerica(response.data.NorthAmerica || false);
          setSthAmerica(response.data.SouthAmerica || false);
          setAustralia(response.data.Australia || false);
          setAntarctica(response.data.Antarctica || false);
          setCountriesNo(response.data.All || 0);
        }
      } catch (error) {
        console.error("Błąd pobierania krajów użytkownika: ", error);
      }
    };

    fetchUserStats();
  }, [userEmail]);

  const maxMemory = storageLimit;
  const percentage = Math.min((storageUsed / maxMemory) * 100, 100);
  const freeMemory = Math.max(maxMemory - storageUsed, 0).toFixed(2);


  let progressColor = '#4caf50'; // Zielony (< 75%)
  if (percentage >= 90) {
    progressColor = '#f44336'; // Czerwony (>= 90%)
  } else if (percentage >= 75) {
    progressColor = '#ff9800'; // Pomarańczowy (>= 75%)
  }


  return (
    <section className="settings-container">
      <header className="settings-header">
        <h1>Ustawienia konta</h1>
        <p className="stats-counter">
          Odblokowałeś <strong>{countriesNo}</strong> z 177 miejsc na mapie
        </p>
      </header>

      <div className="info-row">
        <span className="info-label">Login:</span>
        <span className="info-value">{userEmail}</span>
      </div>
      <div className="info-row">
        <span className="info-label">Hasło:</span>
        <Link to="/reset-hasla" className="link-btn">Zresetuj hasło</Link>
      </div>
      <div className="info-row danger-zone">
        <Link to="/delete-account" className="delete-btn">Usuń konto</Link>
      </div>

      <hr />

      <div className="memory-card">
        <h3>Pamięć dysku</h3>

        <div className="memory-stats-header">
          <span>Zajęte: <strong>{storageUsed} MB</strong> z {storageLimit} MB</span>
          <span className="free-space">Zostało: <strong>{freeMemory} MB</strong></span>
        </div>

        <div className="custom-progress-track">
          <div
            className="custom-progress-fill"
            style={{
              width: `${percentage}%`,
              backgroundColor: progressColor
            }}
          ></div>
        </div>
      </div>

      <section className="badges-section">
        <h2>Odznaki</h2>

        {/* SEKCJA 1: KONTYNENTALNE */}
        <div className="badge-group">
          <h3>Kontynentalne</h3>
          <div className="badges-grid">

            <div className={`badge-card ${europe ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon">⛺</div>
              <div className="badge-title">Pionier Europy</div>
              <div className="badge-desc">Odwiedzono min. 1 kraj w Europie</div>
            </div>

            <div className={`badge-card ${asia ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon">⛩️</div>
              <div className="badge-title">Odkrywca Azji</div>
              <div className="badge-desc">Odwiedź min. 1 kraj w Azji</div>
            </div>

            <div className={`badge-card ${africa ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon">🦁</div>
              <div className="badge-title">Oddech Afryki</div>
              <div className="badge-desc">Odwiedź min. 1 kraj w Afryce</div>
            </div>

            <div className={`badge-card ${nthAmerica ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon">🗽</div>
              <div className="badge-title">Szlak Ameryki Pn.</div>
              <div className="badge-desc">Odwiedź min. 1 kraj w Ameryce Północnej</div>
            </div>

            <div className={`badge-card ${sthAmerica ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon">🦜</div>
              <div className="badge-title">Zew Ameryki Pd.</div>
              <div className="badge-desc">Odwiedź min. 1 kraj w Ameryce Południowej</div>
            </div>

            <div className={`badge-card ${australia ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon">🦘</div>
              <div className="badge-title">Wyprawa do Oceanii</div>
              <div className="badge-desc">Odwiedź min. 1 kraj w Australii / Oceanii</div>
            </div>

            <div className={`badge-card ${antarctica ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon">🐧</div>
              <div className="badge-title">Zdobywca Bieguna</div>
              <div className="badge-desc">Odwiedź obszar Antarktydy</div>
            </div>

          </div>
        </div>

        {/* SEKCJA 2: KAMIENIE MILOWE (ILOŚCIOWE) */}
        <div className="badge-group">
          <h3>Kolekcjoner Świata</h3>
          <div className="badges-grid">

            <div className={`badge-card ${countriesNo >= 1 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">1 🚀</div>
              <div className="badge-title">Pierwszy Krok</div>
              <div className="badge-desc">Odblokuj swój pierwszy kraj</div>
            </div>

            <div className={`badge-card ${countriesNo >= 5 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">5 🧳</div>
              <div className="badge-title">Początkujący Podróżnik</div>
              <div className="badge-desc">Odwiedź 5 różnych krajów</div>
            </div>

            <div className={`badge-card ${countriesNo >= 10 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">10 ✈️</div>
              <div className="badge-title">Mały Obieżyświat</div>
              <div className="badge-desc">Odwiedź 10 różnych krajów</div>
            </div>

            <div className={`badge-card ${countriesNo >= 25 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">25 🗺️</div>
              <div className="badge-title">Łowca Przygód</div>
              <div className="badge-desc">Odwiedź 25 różnych krajów</div>
            </div>

            <div className={`badge-card ${countriesNo >= 50 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">50 🔥</div>
              <div className="badge-title">Wielki Podróżnik</div>
              <div className="badge-desc">Odwiedź 50 różnych krajów</div>
            </div>

            <div className={`badge-card ${countriesNo >= 75 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">75 🌍</div>
              <div className="badge-title">Obywatel Świata</div>
              <div className="badge-desc">Odwiedź 75 różnych krajów</div>
            </div>

            <div className={`badge-card ${countriesNo >= 100 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">100 👑</div>
              <div className="badge-title">Legenda Globusa</div>
              <div className="badge-desc">Odwiedź 100 różnych krajów</div>
            </div>

            <div className={`badge-card ${countriesNo >= 150 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">150 🏆</div>
              <div className="badge-title">Mistrz Kartografii</div>
              <div className="badge-desc">Odwiedź 150 różnych krajów</div>
            </div>

            <div className={`badge-card ultimate ${countriesNo >= 177 ? 'unlocked' : 'locked'}`}>
              <div className="badge-icon number-icon">177 💎</div>
              <div className="badge-title">Zdobywca Świata</div>
              <div className="badge-desc">Odblokuj 100% miejsc na swojej mapie!</div>
            </div>

          </div>
        </div>
      </section>
    </section>
  );
}

export default AccountSettings;